<div
    class="absolute inset-0 flex flex-col h-[calc(100%-30px)] min-w-0 bg-card m-4 rounded-3xl shadow"
    [ngClass]="showPlayerInfo ? 'overflow-y-auto' : 'overflow-hidden'"
>
    <!-- Header -->
    <div class="flex flex-col">
        <div
            class="flex flex-row flex-0 items-center justify-between min-h-[49px]
                   px-2 sm:px-5 py-2 border-b border-black/10 sticky top-0 bg-[#fff] z-10"
        >
            <!-- Breadcrumbs + Live/Test badge -->
            <div class="flex items-center gap-3">
                <div class="hidden sm:flex flex-wrap items-center font-medium text-lg">
                    @for (breadcrumb of breadcrumbs; let i = $index; track breadcrumb.label) {
                        <div class="sm:flex items-center">
                            @if (breadcrumb.link) {
                                <a
                                    [routerLink]="breadcrumb.link"
                                    class="whitespace-nowrap text-gray-700 hover:text-gray-900"
                                >
                                    {{ breadcrumb.label | transloco }}
                                </a>
                            }
                            @if (!breadcrumb.link) {
                                <span
                                    class="whitespace-nowrap text-gray-900 text-center
                                           before:content-[''] before:block before:absolute
                                           before:h-[0.3rem] before:w-[3rem]
                                           before:bg-[#0066cc] before:bottom-0"
                                >
                                    {{ breadcrumb.label | transloco }}
                                </span>
                            }
                            @if (i < breadcrumbs.length - 1) {
                                <mat-icon
                                    class="icon-size-5 text-gray-600"
                                    [svgIcon]="'heroicons_mini:chevron-right'"
                                ></mat-icon>
                            }
                        </div>
                    }
                </div>
                @if(showPlayerInfo){
                  <div>
                    @if(player?.testAccount){
                      <div class="inline-flex items-center px-2.5 py-1 rounded-full text-[10px] font-semibold bg-rose-100 text-rose-800 border border-rose-200 shadow-sm">
                        <mat-icon svgIcon="feather:alert-triangle" class="w-4 h-4 mr-1"></mat-icon>
                        TEST ACCOUNT
                      </div>
                    } @else {
                      <div class="inline-flex items-center px-2.5 py-1 rounded-full text-[10px] font-semibold bg-emerald-100 text-emerald-800 border border-emerald-200 shadow-sm">
                        <mat-icon svgIcon="feather:check-circle" class="w-4 h-4 mr-1"></mat-icon>
                        LIVE ACCOUNT
                      </div>
                    }
                  </div>
                }
                <div class="flex sm:hidden">
                    <a
                        class="inline-flex items-center -ml-1.5 text-secondary font-medium"
                        [routerLink]="'./..'"
                    >
                        <mat-icon
                            class="icon-size-5 text-secondary"
                            [svgIcon]="'heroicons_solid:chevron-left'"
                        ></mat-icon>
                        <span class="ml-1">{{ 'actions.back' | transloco }}</span>
                    </a>
                </div>
            </div>

            <!-- Title -->
            <div>
                <h2
                    class="text-xl sm:text-2xl md:text-3xl font-extrabold tracking-tight
                           leading-6 sm:leading-7 md:leading-10 truncate block"
                >
                    {{ title | transloco }}
                </h2>
            </div>

            <!-- Actions -->
            <div
                class="flex flex-wrap items-center justify-end
                       gap-2 sm:gap-4 mt-3 sm:mt-0 sm:ml-4"
            >
                @if(showPlayerInfo){
                  <!-- Mark/Unmark Test -->
                  @if(player?.testAccount){
                    <button
                      z-button
                      zType="outline"
                      zSize="sm"
                      class="text-rose-700 border-rose-300"
                      (click)="playerCard?.unmarkAsTestAccount()"
                    >
                      <mat-icon svgIcon="feather:slash" class="mr-1 text-sm"></mat-icon>
                      Unmark Test
                    </button>
                  } @else {
                    <button
                      z-button
                      zType="default"
                      zSize="sm"
                      class="bg-rose-600 text-white"
                      (click)="playerCard?.markAsTestAccount()"
                    >
                      <mat-icon svgIcon="feather:flag" class="mr-1 text-sm" style="color: white;"></mat-icon>
                      Mark as Test
                    </button>
                  }

                  <!-- Edit/Cancel/Save -->
                  @if(!playerCard?.editMode){
                    <button
                      z-button
                      zType="default"
                      zSize="sm"
                      class="text-white  flex items-center duration-200 font-medium text-[12px]"
                      (click)="playerCard?.toggleEditMode()"
                    >
                      <mat-icon svgIcon="feather:edit" class="mr-1 text-sm" style="color: white;"></mat-icon>
                      {{ 'actions.edit' | transloco }}
                    </button>
                  } @else {
                    <button
                      z-button
                      zType="outline"
                      zSize="sm"
                      class="text-slate-700 duration-200 font-medium text-[12px]"
                      (click)="playerCard?.toggleEditMode()"
                    >
                      {{ 'actions.cancel' | transloco }}
                    </button>
                    <button
                      z-button
                      zType="default"
                      zSize="sm"
                      class=" duration-200 font-medium text-[12px]"
                      [disabled]="playerCard?.playerForm?.pending || !playerCard?.hasChanges()"
                      (click)="playerCard?.savePlayer()"
                    >
                      {{ 'actions.save' | transloco }}
                    </button>
                  }
                  <span class="mx-2 text-[#dadada]" aria-hidden="true">|</span>
                }

                <!-- Always-visible actions -->
                @if (alwaysVisibleActions && alwaysVisibleActions.length > 0) {
                    @for (visAction of alwaysVisibleActions; let i = $index; track visAction.label) {
                        <ng-container *permission="visAction.permission">
                            @if (visAction.component) {
                                <ng-container *ngComponentOutlet="visAction.component"></ng-container>
                            }
                            @else {
                                @if (!visAction.label) {
                                    <z-button
                                        zType="default"
                                        zSize="lg"
                                        (click)="handleActionClick(visAction)"
                                    >
                                        <mat-icon
                                            class="w-4 h-4 sm:w-6 sm:h-6"
                                            [style.color]="'#0066cc'"
                                            [svgIcon]="visAction.icon"
                                        ></mat-icon>
                                    </z-button>
                                }
                                @else if (visAction.label === 'actions.export') {
                                    <z-button
                                        zType="default"
                                        zSize="lg"
                                        (click)="handleActionClick(visAction)"
                                    >
                                        <mat-icon
                                            class="w-4 h-4 sm:w-6 sm:h-6"
                                            [style.color]="'#0066cc'"
                                            [svgIcon]="visAction.icon"
                                        ></mat-icon>
                                        <span class="text-sm sm:text-base text-black">
                                            {{ visAction.label | transloco }}
                                        </span>
                                    </z-button>
                                }
                                @else {
                                    <z-button
                                        zType="default"
                                        zSize="lg"
                                        (click)="handleActionClick(visAction)"
                                    >
                                        @if (visAction.icon) {
                                            <mat-icon
                                                class="w-4 h-4 sm:w-6 sm:h-6 text-white"
                                                [svgIcon]="visAction.icon"
                                            ></mat-icon>
                                        }
                                        <span class="ml-1">
                                            {{ visAction.label | transloco }}
                                        </span>
                                    </z-button>
                                }
                            }
                        </ng-container>
                        @if (i < alwaysVisibleActions.length - 1) {
                            <span class="mx-2 text-[#dadada]" aria-hidden="true">|</span>
                        }
                    }
                    @if (actions && actions.length > 0) {
                        <span class="mx-2 text-[#dadada]" aria-hidden="true">|</span>
                    }
                }

                <!-- Row-dependent actions (if selected rows) -->
                @if (bulkSelectedRows?.length && rowDependentActions && rowDependentActions.length > 0) {
                    @for (rdAction of rowDependentActions; let i = $index; track rdAction.label) {
                        <ng-container *permission="rdAction.permission">
                            @if (rdAction.component) {
                                <ng-container *ngComponentOutlet="rdAction.component"></ng-container>
                            }
                            @else {
                                @if (!rdAction.label) {
                                    <z-button
                                        zType="default"
                                        zSize="lg"
                                        (click)="handleActionClick(rdAction)"
                                    >
                                        <mat-icon
                                            class="w-4 h-4 sm:w-6 sm:h-6"
                                            [style.color]="'#0066cc'"
                                            [svgIcon]="rdAction.icon"
                                        ></mat-icon>
                                    </z-button>
                                }
                                @else if (rdAction.label === 'actions.export') {
                                    <z-button
                                        zType="default"
                                        zSize="lg"
                                        class="inline-flex items-center gap-1 sm:gap-2
                                               px-2 py-1 sm:px-4 sm:py-2 rounded-md"
                                        (click)="handleActionClick(rdAction)"
                                    >
                                        <mat-icon
                                            class="w-4 h-4 sm:w-6 sm:h-6"
                                            [style.color]="'#0066cc'"
                                            [svgIcon]="rdAction.icon"
                                        ></mat-icon>
                                        <span class="text-sm sm:text-base text-black">
                                            {{ rdAction.label | transloco }}
                                        </span>
                                    </z-button>
                                }
                                @else {
                                    <z-button
                                        zType="default"
                                        zSize="lg"
                                        (click)="handleActionClick(rdAction)"
                                    >
                                        @if (rdAction.icon) {
                                            <mat-icon
                                                class="w-4 h-4 sm:w-6 sm:h-6 text-white"
                                                [svgIcon]="rdAction.icon"
                                            ></mat-icon>
                                        }
                                        <span class="ml-1">
                                            {{ rdAction.label | transloco }}
                                        </span>

                                         @if (rdAction.label === 'settings.casino-management.bulk.manageGames'
                                          && bulkSelectedRows?.length > 0) {
                                         <span
                                       class="text-m font-semibold text-white bg-white/20 rounded-full px-2 py-0.5"
                                       >
                                      {{ bulkSelectedRows.length }}
                                        </span>
                                   }
                                    </z-button>
                                }
                            }
                        </ng-container>
                        @if (i < rowDependentActions.length - 1) {
                            <span class="mx-2 text-[#dadada]" aria-hidden="true">|</span>
                        }
                    }
                    @if (actions && actions.length > 0) {
                        <span class="mx-2 text-[#dadada]" aria-hidden="true">|</span>
                    }
                }

                <!-- Existing bulk action button (if rows selected) -->
                @if (bulkSelectedRows?.length && showBulkActionButton) {
                    <z-button
                        zType="default"
                        zSize="lg"
                        class="bulk-action-button"
                        (click)="handleBulkAction()"
                    >
                        {{ 'players.bulk.title' | transloco }} ({{ bulkSelectedRows.length }})
                    </z-button>
                    @if (actions && actions.length > 0) {
                        <span class="mx-2 text-[#dadada]" aria-hidden="true">|</span>
                    }
                }

                <!-- actions array (classic) -->
                @for (action of actions; let i = $index; track action.label) {
                    <ng-container *permission="action.permission">
                        @if (action.component) {
                            <ng-container *ngComponentOutlet="action.component"></ng-container>
                        }
                        @else {
                            @if (!action.label) {
                                <button
                                    mat-icon-button
                                    (click)="handleActionClick(action)"
                                >
                                    <mat-icon
                                        class="w-4 h-4 sm:w-6 sm:h-6"
                                        [style.color]="'#0066cc'"
                                        [svgIcon]="action.icon"
                                    ></mat-icon>
                                </button>
                            }
                            @else if (action.label === 'actions.export') {
                                <button
                                    mat-button
                                    class="inline-flex items-center gap-1 sm:gap-2
                                           px-2 py-1 sm:px-4 sm:py-2 rounded-md"
                                    (click)="handleActionClick(action)"
                                >
                                    <mat-icon
                                        class="w-4 h-4 sm:w-6 sm:h-6"
                                        [style.color]="'#0066cc'"
                                        [svgIcon]="action.icon"
                                    ></mat-icon>
                                    <span class="text-sm sm:text-base text-black">
                                        {{ action.label | transloco }}
                                    </span>
                                </button>
                            }
                            @else {
                                <button
                                    mat-button
                                    class="bg-[#0066cc] text-white rounded-full
                                           flex items-center
                                           px-3 py-1 sm:px-6 sm:py-1
                                           text-sm sm:text-base"
                                    (click)="handleActionClick(action)"
                                >
                                    @if (action.icon) {
                                        <mat-icon
                                            class="w-4 h-4 sm:w-6 sm:h-6"
                                            [svgIcon]="action.icon"
                                        ></mat-icon>
                                    }
                                    <span class="ml-1">
                                        {{ action.label | transloco }}
                                    </span>
                                </button>
                            }
                        }
                    </ng-container>

                    @if (i < actions.length - 1) {
                        <span class="mx-2 text-[#dadada]" aria-hidden="true">|</span>
                    }
                }
            </div>
        </div>
        <!-- End Header, plus existing header/tabs code... -->

        @if(showPlayerInfo){
            <app-player-card 
              [player]="player" 
              [playerId]="id">
            </app-player-card>
        }

    </div>

    <!-- Bottom area with tabs/routers -->
    <div
      class="px-3 my-auto h-full sm:px-[15px]"
      [ngClass]="showPlayerInfo
        ? 'min-h-[calc(100%-286px)] sm:min-h-[calc(100%-240px)] max-h-[calc(100%-286px)] sm:max-h-[calc(100%-240px)]'
        : 'max-h-full'"
    >
        <!-- Tab changing area with rounded edges -->
        <div class="rounded-xl overflow-hidden mb-4 bg-white shadow-sm">
            <z-tab-group zAlignTabs="start" [zFullWidth]="true" (zOnTabChange)="navigateTo(tabs[$event.index].route)">
                @for (tab of tabs; let i = $index; track tab.label) {
                    <ng-container *permission="tab.permission">
                        <z-tab [label]="(tab.label | transloco)">
                            <ng-container></ng-container>
                        </z-tab>
                    </ng-container>
                }
            </z-tab-group>
        </div>
        <div class="border border-black/10 rounded-xl h-[calc(100%-60px)] lg:h-[calc(100%-70px)] overflow-hidden">
            <mat-tab-nav-panel
                class="flex-auto flex flex-col h-full overflow-y-auto"
                cdkScrollable
                #tabPanel
            >
                <router-outlet></router-outlet>
            </mat-tab-nav-panel>
        </div>
    </div>
</div>
